import React, { useRef, useEffect } from 'react'
import Navbar from '../Navbar'
import { NavLink } from "react-router-dom";
import Footer from '../Footer';
import BlogBg from "../../img/blog.png"
import { SEO } from '../SEO';

function Blog() {
    // Animation refs
    const heroRef = useRef(null);
    const blogGridRef = useRef(null);

    // Animation observer effect
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry: any) => {
                if (entry.isIntersecting) {
                    // Hero animation
                    if (entry.target === heroRef.current) {
                        const title = entry.target.querySelector('.hero-title')
                        const subtitle = entry.target.querySelector('.hero-subtitle')

                        if (title) {
                            setTimeout(() => {
                                title.classList.add('animate-fade-in-up')
                            }, 100)
                        }

                        if (subtitle) {
                            setTimeout(() => {
                                subtitle.classList.add('animate-fade-in-up')
                            }, 250)
                        }
                    }

                    // Blog cards animation
                    if (entry.target === blogGridRef.current) {
                        const blogCards = entry.target.querySelectorAll('.blog-card')
                        blogCards.forEach((card: any, index: any) => {
                            setTimeout(() => {
                                card.classList.add('animate-scale-in')
                            }, index * 100)
                        })
                    }

                    observer.unobserve(entry.target)
                }
            })
        }, observerOptions)

        if (heroRef.current) observer.observe(heroRef.current)
        if (blogGridRef.current) observer.observe(blogGridRef.current)

        return () => observer.disconnect()
    }, [])

    return (
        <>
            <style>{`
                .initial-hidden {
                    opacity: 0;
                    transform: translateY(20px);
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes scaleIn {
                    from {
                        opacity: 0;
                        transform: scale(0.9);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }

                .animate-fade-in-up {
                    animation: fadeInUp 0.6s ease-out forwards;
                }

                .animate-scale-in {
                    animation: scaleIn 0.5s ease-out forwards;
                }

                .blog-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .blog-card:hover {
                    transform: translateY(-8px);
                    
                }
            `}</style>

            <SEO
                title="Blogs | Afripay"
                description="Read all blogs and articles on Afripay."
                canonical="https://goafripay.com/blog"
            />

            <Navbar />

            <div className='pt-16'>
                {/* Hero Section */}
                <div ref={heroRef} className='bg-[#001E0E] lg:px-14 px-6 md:pb-20 pb-10 mx-auto flex flex-col lg:justify-center lg:space-x-14'>
                    <div className="place-self-center text-center md:pt-28 md:pb-10 pt-8">
                        <h1 className="hero-title initial-hidden text-3xl sm:text-4xl lg:text-5xl text-white font-display font-bold leading-tight tracking-[-0.02em]">
                            Blogs
                        </h1>

                        <p className="hero-subtitle initial-hidden md:mt-5 mt-2 text-base sm:text-lg text-white font-body font-medium opacity-90">
                            Get News with AfriPay
                        </p>
                    </div>
                </div>
            </div>

            {/* Blog Section */}
            <section className="bg-[#FAFBFC] font-body py-16">
                <div ref={blogGridRef} className='lg:px-16 mx-auto px-8 pt-3'>
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-8">



                        {/* Blog Card 1 */}
                        <div className='blog-card initial-hidden'>
                            <div className='relative'>
                                <img src="/images/blog-tuition-payment.avif" alt="blog" className='rounded-[10px] w-full' />
                            </div>
                            <div className='mt-2'>
                                <h3 className='md:text-[20px] text-[18px] text-[#3A3939] font-medium'>Tuition Payment</h3>
                                <p className='md:text-[12px] text-[10px] text-[#6C6A6A] mt-1'>Paying Tuition Abroad Has Never Been Easier With AfriPay</p>
                            </div>
                            <NavLink to="/tuition-payment-blog">
                                <div className='mt-2'>
                                    <button className='w-full text-[#ffffff] bg-[#0B7F47] hover:bg-[#0a3d26] border-2 border-[#7FBC51] shadow-sm p-[10px] rounded-[10px] transition-all duration-300'>Learn More</button>
                                </div>
                            </NavLink>
                        </div>

                        {/* Blog Card 1 */}
                        <div className='blog-card initial-hidden'>
                            <div className='relative'>
                                <img src="/images/blog-global-financial-connectivity.avif" alt="blog" className='rounded-[10px] w-full' />
                            </div>
                            <div className='mt-2'>
                                <h3 className='md:text-[20px] text-[18px] text-[#3A3939] font-medium'>Global Financial Connectivity</h3>
                                <p className='md:text-[12px] text-[10px] text-[#6C6A6A] mt-1'>AfriPay — Connecting Africa to the World’s Financial System</p>
                            </div>
                            <NavLink to="/global-financial-connectivity-blog">
                                <div className='mt-2'>
                                    <button className='w-full text-[#ffffff] bg-[#0B7F47] hover:bg-[#0a3d26] border-2 border-[#7FBC51] shadow-sm p-[10px] rounded-[10px] transition-all duration-300'>Learn More</button>
                                </div>
                            </NavLink>
                        </div>

                        {/* Blog Card 1 */}
                        <div className='blog-card initial-hidden'>
                            <div className='relative'>
                                <img src="/images/blog-student-loan.avif" alt="blog" className='rounded-[10px] w-full' />
                            </div>
                            <div className='mt-2'>
                                <h3 className='md:text-[20px] text-[18px] text-[#3A3939] font-medium'>AfriPay Student Loans — Smarter Funding for Your Global Education Journey</h3>
                                <p className='md:text-[12px] text-[10px] text-[#6C6A6A] mt-1'>Student Loans have been made smarter and easier with Afripay</p>
                            </div>
                            <NavLink to="/student-loan-blog">
                                <div className='mt-2'>
                                    <button className='w-full text-[#ffffff] bg-[#0B7F47] hover:bg-[#0a3d26] border-2 border-[#7FBC51] shadow-sm p-[10px] rounded-[10px] transition-all duration-300'>Learn More</button>
                                </div>
                            </NavLink>
                        </div>

                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default Blog